<template>
<div class="profile">
  <!-- <breadcrumb v-bind:path2="path2"></breadcrumb> -->
  <div class="warpInfo">
    <div class="top">
      <div class="left">
        <input type="file" id="file1" name="image" ref="uploadInput" accept="image/*" capture style="display:none" @change="fileChange" />
        <!-- <img src="../../assets/img/user.png" class="avatar" v-if="!temp" alt=""> -->
        <input type="image" v-if="!temp" :src="notemp" alt="Avatar" class="avatar" style="outline: none" @click="uploadImg"/>
        <input type="image" v-else :src="temp" alt="Avatar" class="avatar" style="outline: none" @click="uploadImg"/>
        <div class="name">
          <span>{{this.$store.state.auth.userDetails.FirstName}}</span>
          <p>{{ $t('accountInformation') }}</p>
        </div>
      </div>
      <div class="right" @click="handleNavToAccountFromNavbar('friends')">{{ $t('invite_friends') }}</div>
    </div>
  </div>
  <div class="resemble">
    <div class="content">
      <div class="left">
        <ul>
          <li :class="componentDisplayOnAccount==='informations' ?'bold':''" @click="handleNavToAccountFromNavbar('informations')">
            <i class="el-icon-s-operation"></i>
            <span>{{ $t('account') }}</span>
          </li>
          <li :class="componentDisplayOnAccount==='addresses' ?'bold':''" @click="handleNavToAccountFromNavbar('addresses')">
            <i class="el-icon-goods"></i>
            <span>{{ $t('address') }}</span>
          </li>
          <li :class="componentDisplayOnAccount==='orders' ?'bold':''" @click="handleNavToAccountFromNavbar('orders')">
            <i class="el-icon-office-building"></i>
            <span>{{ $t('orders') }}</span>
          </li>
          <li :class="componentDisplayOnAccount==='friends' ?'bold':''" @click="handleNavToAccountFromNavbar('friends')">
            <i class="el-icon-user"></i>
            <span>{{ $t('invite') }}</span>
          </li>
          <li @click="logout()" v-if="isMobile">
            <i class="el-icon-user"></i>
            <span>{{ $t('logOut') }}</span>
          </li>
        </ul>
      </div>
      <div class="right">
        <Friends v-if="componentDisplayOnAccount==='friends'" />
        <Order v-if="componentDisplayOnAccount==='orders'" />
        <Address v-if="componentDisplayOnAccount==='addresses'" />
        <Information v-if="componentDisplayOnAccount==='informations'" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import breadcrumb from "@/components/breadcrumb";
import Address from './address';
import Friends from './friends';
import Information from './information';
import Order from './order';
import productCard from "../productCard";
import temp from '../../assets/img/user.png';
import { isUserAuthenticated, flyToElement } from "../../store/modules/cart";

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

export default {
  name: 'profile',
  components: {
    breadcrumb,
    Order,
    Address,
    Friends,
    Information,
    productCard,
  },
  data() {
    return {
      path2: this.$t('account'),
      currentTab: "order",
      temp: temp,
      notemp: require("../../assets/img/user.png"),
      isMobile: isMobile,
      productSwiper: {
        slidesPerView: 5,
        navigation: {
          nextEl: '.swiper-button-next.swp2',
          prevEl: '.swiper-button-prev.swp2',
        },
        breakpoints: {
          320: {
            slidesPerView: 2,
          },
          //when width >= 480
          480:{
            slidesPerView: 2,
          },
          767: {
            slidesPerView: 2,
          },
          //when width >= 640
          990: {
            slidesPerView: 3,
          },
          1200:{
            slidesPerView: 4,
          },
          1280: {
            slidesPerView: 5,
          }
        }
      },
      inCart: null,
    }
  },
  methods: {
    ...mapActions('cart', ['addProductToCart']),
    ...mapActions('products', ['fetchProductDetails']),
    ...mapActions('profile', ['updateUserPhoto']),
    ...mapMutations('navbar', ['handleNavToAccountFromNavbar']),
    ...mapMutations('auth', ['logout']),
    ...mapMutations('checkout', ['setPricesForCheckout', 'saveTotalPrice', 'saveGrandTotal', 'clearPromoCode', 'clearCard']),
    ...mapMutations('products', ['updateActiveProduct']),
    handleAddToCartSuccess(item) {
      this.$store.dispatch('cart/addCart', item)
      .then(() => {
        this.$store.dispatch('cart/getCart');
      });
    },
    handleAddToCartFail() {
      alert('Not enough product in stock');
    },
    findRightElement(item, p) {
      if (item.Product_id === p) {
        return 
      }
    },
    addToCart: function(item, event) {
      if (isUserAuthenticated()) {
        this.addProductToCart({success: this.handleAddToCartSuccess, fail: this.handleAddToCartFail, item})
        .then(() => {
          flyToElement(event.target, $('.cart-link'));
        })
      } else {
        this.$store.dispatch('cart/addProductToLocalCart', item)
        .then(() => {
          this.$store.dispatch('cart/getCart');
          flyToElement(event.target, $('.cart-link'));
        })
      }
    },
    uploadImg() {
      this.$refs.uploadInput.click()
    },
    toBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      })
    },
    async fileChange() {
      const file = await this.toBase64(this.$refs.uploadInput.files[0]);
      this.updateUserPhoto({ "profile": file })
      .then(res=> {
        this.temp = res.data;
      })
      .catch(err => {
        console.log('err updating user photo', err)
      })
    }
  },
  computed: mapState({
    componentDisplayOnAccount: state => state.navbar.componentDisplayOnAccount,
    cartProductsList: state => state.cart.cartProductsList,
    token: state => state.auth.token,
    itemCount: state => state.cart.itemCount,
    necessaryCartItems: state => state.cart.necessaryCartItems,
    cartClicked: state => state.cart.cartClicked,
    itemAdded: state => state.cart.itemAdded,
    userDetails: state => state.auth.userDetails,
  }),
  mounted() {
    this.$store.dispatch('products/fetchCustomCategories');
    if(this.userDetails) {
      this.temp = this.userDetails.profile_picture
    }
  },
  watch: {
    itemCount: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (isUserAuthenticated()) {
          this.$store.dispatch('cart/getCart');
        } else {
          this.$store.dispatch('cart/fetchCartProducts');
        }
      }
    },
    '$store.state.auth.userDetails': {
      immidiate: true,
      handler(newval) {
        this.temp = newval.profile_picture;
      }
    }  
  }
}
</script>

<style lang="less" scope>
@import "../../assets/css/profile.less";
@import "../../assets/css/home.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/index.vue